<template>
  <section class="banner">
    <div class="container">
      <a-row>
        <a-col :xs="24">
          <a-typography-title :level="1">
            星汉未来资料中心
          </a-typography-title>
          <!--<a-input v-model:value="form.data.search" placeholder="搜索"-->
          <!--         class="box_input" size="large"-->
          <!--         :maxlength="20" :show-count="form.data.search.length>0"-->
          <!--         @pressEnter="pressEnter" allow-clear>-->
          <!--    <template #prefix>-->
          <!--        <SearchOutlined />-->
          <!--    </template>-->
          <!--</a-input>-->
        </a-col>
      </a-row>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { SearchOutlined } from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';

export default {
  name: 'databaseBanner',
  components: {
    SearchOutlined
  },
  data(): DataInterface {
    return {
      // form: {
      //     data: {
      //         search: ''
      //     }
      // }
    };
  },
  methods: {
    // /**
    //  * 按下回车
    //  */
    // async pressEnter(): Promise<any> {
    //     console.log(this.form.data.search);
    // }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/database/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    width: 100%;
    height: 100%;
    padding: 180px 0 140px;
    margin: 0 auto;
  }
}

h1.ant-typography {
  margin: 0;
  .font(justify, @banner_title, @color_white, @banner_title, true);
}

.box_input {
  height: 50px;
  margin: @margin 0 0;
  
  .ant-input-prefix {
    .anticon {
      color: @color_6;
      font-size: 24px;
      margin-right: 5px;
    }
  }
  
  &:deep(.ant-input) {
    font-size: 18px;
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 100px 0 50px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  h1.ant-typography {
    .font(center, @banner_title_mo, @color_white, @banner_title_mo, true);
  }
  
  .box_input {
    height: 30px;
    margin: @margin_mo 0 0;
    
    .ant-input-prefix {
      .anticon {
        font-size: 20px;
      }
    }
    
    &:deep(.ant-input) {
      font-size: 16px;
    }
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>